module.exports = "https://web-assets.ifttt.com/packs/media/partners/ifttt_platform_wordmark-45c4782d.svg";